'use client'

import Image from 'next/image'
import Link from 'next/link'
import { usePathname } from 'next/navigation'
import { useLocale } from 'next-intl'
import { useState } from 'react'
import {
    INavigationDesktopItemProps,
    NavigationDesktopItem,
} from '@/features/navigation/navigation-desktop-item'
import { Locale } from '@/setup/locales'
import { getLinkHref, getPathname } from '@/setup/routing'

interface INavigationDesktopProps {
    items: Omit<INavigationDesktopItemProps, 'isActive'>[]
}

export const NavigationDesktop = ({ items }: INavigationDesktopProps) => {
    const locale = useLocale()

    const [hoveredItem, setHoveredItem] = useState<string | null>(null)

    // Don't use usePathname from i18n, but instead use the one from next/navigation
    const pathname = usePathname()

    return (
        <nav className="w-full flex justify-center md:border-b md:border-b-border-secondary">
            <div className="hidden md:flex flex-row items-center justify-between w-full min-h-[80px] h-[80px] navigation-width">
                <Link
                    href={getLinkHref({ pattern: '/', params: undefined }, locale as Locale)}
                    className="min-h-[32px] min-w-[155px]"
                >
                    <Image
                        src="/_images/navigation/neotaste-navigation-logo.svg"
                        alt="NeoTaste Logo"
                        width={155}
                        height={32}
                        priority
                        className="min-h-[32px] min-w-[155px]"
                    />
                </Link>

                <div className="flex flex-row items-center">
                    {items.map((item) => {
                        const itemPathname =
                            'externalUrl' in item.linkParams
                                ? undefined
                                : getPathname(
                                      item.linkParams.pattern,
                                      item.linkParams.params,
                                      locale as Locale
                                  )

                        const id =
                            'externalUrl' in item.linkParams
                                ? item.linkParams.externalUrl
                                : item.linkParams.pattern

                        return (
                            <NavigationDesktopItem
                                key={'naviation' + item.label}
                                onMouseEnter={() => setHoveredItem(id)}
                                onMouseLeave={() => setHoveredItem(null)}
                                isHovered={Boolean(hoveredItem === id)}
                                isActive={Boolean(itemPathname === pathname)}
                                {...item}
                            />
                        )
                    })}
                </div>
            </div>
        </nav>
    )
}
